export default {"src":"/_next/static/media/surgeon_40.407af945.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};